import * as React from 'react'
import { Field, useFormikContext } from 'formik'
import { MuiTextFieldFormik } from '@user/components/Formik'
import { ActivityType } from '../../../typings'

const maxLength = 30
const inputProps = { maxLength: maxLength }

export function Name() {
  const { values } = useFormikContext<ActivityType>()
  const helperText = `${values.name?.length ?? 0}/${maxLength}`
  return (
    <Field
      required
      fullWidth
      size="small"
      name="name"
      label="Activity Name"
      margin="normal"
      component={MuiTextFieldFormik}
      inputProps={inputProps}
      helperText={helperText}
    />
  )
}
